"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalRegionalTouristLicence = void 0;
const React = __importStar(require("react"));
const FormInput_1 = require("../../../../components/input/text/FormInput");
const Spacer_1 = require("../../../../components/spacer/Spacer");
const Paragraph_1 = require("../../../../components/paragraph/Paragraph");
;
const RequiredRegions = {
    fr: ['Biarritz', 'Bordeaux', 'Cannes', 'Lyon', 'Menton', 'Nice', 'Paris', 'Versailles'],
    es: ['Balearic Islands', 'Catalonia', 'Valencia'],
    in: ['Goa']
};
const OptionalRegionalTouristLicence = (props) => {
    var _a;
    const { property, update } = props;
    const { country_code, local_licence } = property;
    const regions = RequiredRegions[country_code];
    return (React.createElement("div", { role: "group", "aria-labelledby": "tourist-licence-header" },
        regions && React.createElement(Paragraph_1.Paragraph, null,
            "If your property is in one of the following regions, we'll require a local licence number before we can list your property:",
            React.createElement("ul", null, regions.map((r) => React.createElement("li", { key: r }, r)))),
        React.createElement(Spacer_1.Spacer, null),
        React.createElement(FormInput_1.FormInput, { required: false, noCharCount: true, label: "Local licence number", id: "local-licence-number-input", value: (_a = local_licence === null || local_licence === void 0 ? void 0 : local_licence.number) !== null && _a !== void 0 ? _a : '', onChange: (e) => update(Object.assign(Object.assign({}, property), { local_licence: Object.assign(Object.assign({}, local_licence), { number: e.target.value }) })) })));
};
exports.OptionalRegionalTouristLicence = OptionalRegionalTouristLicence;
//# sourceMappingURL=OptionalRegionalTouristLicence.js.map